import { createCrosshairOverlay } from "../overlays/crosshairOverlay";
import { createInteraction } from "./createInteraction";

/**
 * Crosshair layer and gestures of the engine. After every frame it reports
 * the visible range (engine.events) and redraws the crosshair with the new
 * layout.
 *
 * @param {object} engine - ChartEngine with its scales, data, layers and events
 * @param {HTMLElement} container
 */
export const attachInteraction = (engine, container) => {
  const { timeScale, priceScale, data, timeAxis, theme, textLayer, events, scheduler, positions, paneStack, drawings } =
    engine;
  const overlay = createCrosshairOverlay(container, {
    timeScale,
    priceScale,
    data,
    timeAxis,
    theme,
    measure: textLayer.measure,
    isSnapEnabled: () => engine.toggles.gridSnapEnabled,
    onCrosshairChange: events.emitCrosshair,
  });
  const input = createInteraction(container, {
    timeScale,
    priceScale,
    overlay,
    positions,
    drawings,
    paneStack,
    animate: scheduler.animate,
    invalidate: () => engine.invalidate(),
  });

  return {
    /** Crosshair of the last draw (see resolveCrosshair), null when hidden. */
    get crosshair() {
      return overlay.crosshair;
    },

    resize: overlay.resize,

    cancelGesture: input.cancelGesture,

    /** @param {{ range: { first: number, last: number }, priceAxisWidth: number }} layout - of the frame just drawn */
    afterFrame: (layout) => {
      events.emitVisibleRange(timeScale, layout, data.barDurationMs);
      events.emitPaneLayout(layout);
      overlay.render(layout);
    },

    destroy: () => {
      input.destroy();
      overlay.destroy();
    },
  };
};
